import React, { Component } from 'react';
import PageTitle from './PageTitle'; 
import {Link} from 'react-router';

export default class AboutEducational extends Component {

    render() {
        return (
            <div>
                <PageTitle title="Gestão Educional - Sistema SIGA" last="Home" lastLink="/" />
                <div className="promo-box brand-bg">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="promo-info">
                                <span className="white-text text-uppercase">Integre os setores Acadêmico, Pedagógico e Financeiro de sua Instituição!</span>
                                <h2 className="font-30 white-text text-bold text-uppercase no-margin">Quer saber mais, agende uma demonstração</h2>
                            </div>
                            <div className="promo-btn">
                                <Link className="btn white waves-effect waves-grey" to="/contact/agendar-demonstração">Agendar agora</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <section id="about" className="section-padding">
                    <div className="container">

                        <div className="text-center mb-80">
                            <h2 className="section-title text-uppercase">Sistema SIGA</h2>
                            <p className="section-sub">O Sistema SIGA tem tudo que sua insituição de ensino precisa.</p>
                        </div>

                        <div className="vertical-tab">
                            <div className="row">
                                <div className="col-sm-3">
                                    <ul className="nav nav-tabs nav-stacked hidden-xs" role="tablist">
                                        <li role="presentation" className="active"><a href="#tab-5" className="waves-effect waves-light" role="tab" data-toggle="tab" aria-expanded="false">Gestão Financeiro</a></li>
                                        <li role="presentation" className=""><a href="#tab-6" className="waves-effect waves-light" role="tab" data-toggle="tab" aria-expanded="false">Gestão Acadêmica e pedagogica</a></li>
                                        <li role="presentation" className=""><a href="#tab-7" className="waves-effect waves-light" role="tab" data-toggle="tab" aria-expanded="false">Captação de alunos e gerenciamento de contatos</a></li>
                                        <li role="presentation" className=""><a href="#tab-8" className="waves-effect waves-light" role="tab" data-toggle="tab" aria-expanded="false">Planejamento Orçamentario</a></li>
                                        <li role="presentation" className=""><a href="#tab-9" className="waves-effect waves-light" role="tab" data-toggle="tab" aria-expanded="false">Portal dos professores e Coordenadores</a></li>
                                        <li role="presentation" className=""><a href="#tab-10" className="waves-effect waves-light" role="tab" data-toggle="tab" aria-expanded="true">Portal dos alunos e responsavéis</a></li>
                                    </ul><div className="panel-group visible-xs" id="undefined-accordion"></div>
                                </div>

                                <div className="col-sm-9">
                                    <div className="panel-body">
                                        <div className="tab-content">
                                            <div role="tabpanel" className="tab-pane fade in active" id="tab-5">
                                                <h2>Gestão Financeira Completa</h2>

                                                <img className="alignright" width="150px" src="/assets/img/mockup/tab.png" alt="" />

                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Boletos Bancários (emissão de boletos, geração de arquivos remessa e retorno).
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de Fluxo de Caixa.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Resumo Financeiro de Alunos.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de inadimplência.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Geração de Renegociações.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de descontos/convênios.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Emissão de Declaração de Pagamentos
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-sm-4">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de Planos de Contas.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle das contas a pagar.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Demonstrativo de resultados (DRE).
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Conciliação Bancária.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de receitas extras.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Visão geral do cenário atual.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Gráficos/Relatórios gerenciais.
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div role="tabpanel" className="tab-pane fade" id="tab-6">
                                                <h2>Gestão Acadêmica e pedagógica</h2>
                                                
                                                <img className="alignright mt-20" width="250px" src="/assets/img/idea.jpg" alt="" />

                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de matrículas.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Contrato/Requerimento de matrículas.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Emissão do Boletim Escolar.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Emissão Histórico Escolar.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Emissão de Certificados/Diplomas.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Emissão da Ata de Resultados Finais.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Ficha Cadastral do aluno
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de Ocorrências dos alunos.
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-sm-4">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de avaliações do aluno.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de faltas do aluno.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle das turmas.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle do aproveitamento dos professores.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Emissão de declarações do aluno.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Visão geral do cenário atual.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Rematrícula coletiva.
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>


                                            </div>
                                            <div role="tabpanel" className="tab-pane fade" id="tab-7">
                                                <h2>Captação de alunos e gerenciamento de contatos</h2>

                                                <img className="alignright" width="250px" src="/assets/img/busy_man.png" alt="" />

                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de contatos por tipo (Email, WhatsApp ...).
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Agendamento de contatos futuros.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de aproveitamento de alunos interessados.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Importação de base de dados em Excel.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Reagendamento de contatos e acompanhamento.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de orçamento do interessado.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de contatos por categoria.
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div className="col-sm-4">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de tarefas entre colaborados.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de captação de alunos novos.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de atualização das informações do aluno.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle rendimento de captação de alunos por funcionario.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle rendimento de captação de alunos por setor.
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                            </div>
                                            <div role="tabpanel" className="tab-pane fade" id="tab-8">
                                                <h2>Planejamento Orçamentario</h2>

                                                <img className="alignright" src="/assets/img/data.png" alt="" width="250px" />

                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de contas contábeis.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de centros de custo.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de planos de contas.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle plano orçamentário anual.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de versões do plano orçamentário.
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div className="col-sm-4">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle plano orçamentario mensal.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Comparativo Planejado/Realizado/Saldo.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Exportação grade orçamentária em Excel.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Visual resultado final.
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div role="tabpanel" className="tab-pane fade" id="tab-9">
                                                <h2>Portal dos professores e Coordenadores</h2>

                                                <img className="alignright" src="/assets/img/business.png" alt="" width="250px" />

                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Lançamento de Notas.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Lançamento de Avaliações.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de conteúdos ministrados.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Emissão Diário de Classe.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle material didático.
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div className="col-sm-4">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Lançamento de Ocorrências.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Lançamento de Faltas.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Lançamento plano de aula.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Lançamento plano de ensino.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de documentos anexos da turma.
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                            </div>
                                            <div role="tabpanel" className="tab-pane fade" id="tab-10">
                                                <h2>Portal dos Alunos e Responsavéis</h2>

                                                <img className="alignright" src="/assets/img/working_man.png" alt="" width="250px" />

                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Publicação de Documentos Parametrizados.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Publicação de Avisos.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Publicação de Links (Vídeos, Monitoramento de Câmeras, etc.).
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Publicações Acadêmicas (Boletim, ocorrência, ficha avaliativa, registros de acesso).
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Publicação de Arquivos (PDF)
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div className="col-sm-4">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Publicações Financeiras (Boletos, cobrança, declaração de pagamentos).
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Publicação de Anexos da Turma.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Consulta de Faltas/Ocorrências.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Publicação dos Horários da turma.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Publicação dados do aluno.
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
                <section className="facts-two counter-section seo-banner-1 bg-fixed parallax-bg overlay dark-6" data-stellar-background-ratio="0.5" style={{backgroundImage: 'url(../../assets/img/seo/seo-banner-1.jpg)', backgroundPosition: '0% 140.5px'}}>
                    <div className="container">
                        <div className="row text-center">
                            <div className="col-sm-3 counter-wrap">
                                <i className="material-icons brand-color"></i>
                                <span className="timer white-text">500000</span>
                                <span className="count-description white-text">Alunos cadastrados</span>
                            </div>

                            <div className="col-sm-3 counter-wrap">
                                <i className="material-icons brand-color"></i>
                                <span className="timer white-text">286760</span>
                                <span className="count-description white-text">Matrículas</span>
                            </div>

                            <div className="col-sm-3 counter-wrap">
                                <i className="material-icons brand-color"></i>
                                <span className="timer white-text">100000</span>
                                <span className="count-description white-text">Visitas mensais</span>
                            </div>

                            <div className="col-sm-3 counter-wrap">
                                <i className="material-icons brand-color"></i>
                                <span className="timer white-text">47000</span>
                                <span className="count-description white-text">Usuários</span>
                            </div>                           
                        </div>
                    </div>
                </section>
                <section className="bg-fixed parallax-bg overlay light-7 mb-100 mt-100">
                    <div className="container">
                    <div className="row">
                        <div className="col-md-7 dark-text">
                            
                            <p>Entre em contato conosco e solicite seu orçamento. </p>

                            <ul className="list-icon mb-30">
                                <li><i className="material-icons"></i> Backup automatizado.</li>
                                <li><i className="material-icons"></i> Sistema 100% Online.</li>
                                <li><i className="material-icons"></i> Suporte/Atendimento Online e presencial.</li>
                                <li><i className="material-icons"></i> Orçamento sem nenhum compromisso.</li>
                            </ul>

                            <Link to="/contact/fazer-orçamento" className="btn btn-lg text-capitalize waves-effect waves-light">Fazer orçamento</Link>
                            

                        </div>

                        <div className="col-md-5 mt-sm-30">
                            <img className="alignright" src="/assets/img/seo/tab-2.png" alt="" />
                        </div>
                    </div>
                </div>
            </section>                
         </div>    
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AboutEducational.js